function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFotovoltaickeElektrarny(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 142.87 153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "26.49 56.37 3.42 93.68 139.34 93.68 116.84 56.37 26.49 56.37",
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.36,
    y1: 74.85,
    x2: 127.86,
    y2: 74.85,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.49,
    y1: 94.82,
    x2: 64.49,
    y2: 139.36,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.72,
    y1: 94.82,
    x2: 78.72,
    y2: 139.36,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.91,
    y1: 56.48,
    x2: 31.89,
    y2: 93.91,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.73,
    y1: 56.6,
    x2: 57.83,
    y2: 92.87,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.36,
    y1: 56.6,
    x2: 84.69,
    y2: 92.41,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.19,
    y1: 57.06,
    x2: 110.64,
    y2: 93.33,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.51,130.18v-13.09c0-4.48,5.51-7.69,8.04-8.72s5.17-1.49,5.17-1.49c0,0,2.3,8.61-1.61,12.63-3.9,4.02-9.18,4.36-12.86,4.36s-9.99-1.84-11.48-7.23-.23-9.3-.23-9.3c0,0,7-2.07,12.74,7.92",
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.41,139.82s0-.08,0-.11c0-4.75-5.11-8.61-11.42-8.61s-11.42,3.85-11.42,8.61c0,.04,0,.08,0,.11h-59.36s0-.08,0-.11c0-4.75-5.11-8.61-11.42-8.61s-11.42,3.85-11.42,8.61c0,.04,0,.08,0,.11H2.5v10.68h137.87v-10.68h-15.96Z",
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.7,130.18v-13.09c0-4.48,5.51-7.69,8.04-8.72s5.17-1.49,5.17-1.49c0,0,2.3,8.61-1.61,12.63-3.9,4.02-9.18,4.36-12.86,4.36s-9.99-1.84-11.48-7.23-.23-9.3-.23-9.3c0,0,7-2.07,12.74,7.92",
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.15,
    cy: 24,
    r: 9.87,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.38,
    y1: 2.5,
    x2: 71.38,
    y2: 6.2,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.38,
    y1: 41.76,
    x2: 71.38,
    y2: 45.46,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.86,
    y1: 23.98,
    x2: 89.16,
    y2: 23.98,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.6,
    y1: 23.98,
    x2: 49.9,
    y2: 23.98,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.57,
    y1: 8.79,
    x2: 83.95,
    y2: 11.41,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.81,
    y1: 36.55,
    x2: 56.19,
    y2: 39.17,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.57,
    y1: 39.17,
    x2: 83.95,
    y2: 36.55,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.81,
    y1: 11.41,
    x2: 56.19,
    y2: 8.79,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFotovoltaickeElektrarny);
export default __webpack_public_path__ + "static/media/fotovoltaicke-elektrarny.95357bec6a652a9bd25daf4a0f64cde4.svg";
export { ForwardRef as ReactComponent };